import { render, staticRenderFns } from "./BugReport.vue?vue&type=template&id=0664f396&"
import script from "./BugReport.vue?vue&type=script&lang=ts&"
export * from "./BugReport.vue?vue&type=script&lang=ts&"
import style0 from "./BugReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports